import { useEffect, useState } from "react";
import { useHomeData } from "../../context/HomeContext";
import { urlFor } from "../../utils/imageUrl";

import "./index.css";
import GRADIENT from "../../Assets/logos/gradient_logo.svg";

export const Hero = () => {
  const homeData = useHomeData();
  const data = homeData?.hero || null;

  const [width] = useState(window.innerWidth);
  const [visible, setVisible] = useState(true);
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setVisible(scrollTop < window.innerHeight);
      setScrolling(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    let startY = 0;

    const handleTouchMove = (event) => {
      const currentY = event.touches[0].clientY;
      const deltaY = currentY - startY;
      setVisible(deltaY > 200 || window.scrollY === 0);
      startY = currentY;
    };

    window.addEventListener("touchstart", (event) => {
      startY = event.touches[0].clientY;
    });

    window.addEventListener("touchmove", handleTouchMove);

    return () => {
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <>
      <section className="hero">
        {data && data.backgroundImage && (
          <img
            className="background-image"
            src={urlFor(data.backgroundImage.asset._ref).width(1920).url()}
            alt=""
          />
        )}
        {data && data.logo && (
          <a href="/" className={`${visible ? "show" : "hide"}`}>
            <img
              className={`logo ${scrolling && width > 768 ? "scrolling" : ""}`}
              src={urlFor(data.logo.asset._ref).width(900).url()}
              alt="Logo"
            />
            <img
              className={`logo gradient ${scrolling ? "scrolling" : ""}`}
              src={GRADIENT}
              alt=""
            />
          </a>
        )}
      </section>
    </>
  );
};
